import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from '../../../../utils/api'

import { MENTOR_GUIDANCE_TYPE } from './Index'

const getBaseUrl = (apiData, mentorGuidanceContext, type, isMutation) => {
  let url = `${getApiBaseUrlWithOrg(apiData.orgId)}${
    isMutation ? '/mentor' : ''
  }/course_sections/${mentorGuidanceContext.courseSectionId}`

  switch (type) {
    case MENTOR_GUIDANCE_TYPE.LEVEL:
      url += `/mentor_guidances/level/${mentorGuidanceContext.levelId}`
      break

    case MENTOR_GUIDANCE_TYPE.QUEST:
      url += `/levels/${mentorGuidanceContext.levelId}/mentor_guidances/quest/${mentorGuidanceContext.questId}`
      break

    case MENTOR_GUIDANCE_TYPE.JOURNEY:
      url += `/mentor_guidances/course/${mentorGuidanceContext.courseId}`
      break

    default:
      url += `/levels/${mentorGuidanceContext.levelId}/mentor_guidances/activity/${mentorGuidanceContext.activityId}`
      break
  }

  return url
}

export const fetchMentorGuidance = async (
  apiData,
  mentorGuidanceContext,
  type
) => {
  const url = getBaseUrl(apiData, mentorGuidanceContext, type, false)
  const response = checkHttpStatus(
    await fetch(url, {
      method: 'GET',
      headers: getApiHeadersFromToken(apiData.token)
    })
  )
  return await response.json()
}

export const mutateMentorGuidance = async (
  apiData,
  mentorGuidanceContext,
  type,
  guidance,
  applyToAllSections = false,
  guidanceText = null
) => {
  let url = getBaseUrl(apiData, mentorGuidanceContext, type, true)

  if (guidance) {
    url += '/' + guidance.id
  }

  const response = checkHttpStatus(
    await fetch(url, {
      method: guidance ? 'PUT' : 'POST',
      headers: getApiHeadersFromToken(apiData.token),
      body: JSON.stringify({
        apply_to_all_sections: applyToAllSections,
        mentor_guidance: { text: guidanceText }
      })
    })
  )
  return await response.json()
}

export const deleteMentorGuidance = async (
  apiData,
  mentorGuidanceContext,
  type,
  guidance,
  applyToAllSections = false
) => {
  const url =
    getBaseUrl(apiData, mentorGuidanceContext, type, true) + '/' + guidance.id
  checkHttpStatus(
    await fetch(url, {
      method: 'DELETE',
      headers: getApiHeadersFromToken(apiData.token),
      body: JSON.stringify({
        apply_to_all_sections: applyToAllSections
      })
    })
  )
}
